
<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open -extra-width">
  <div class="esf-main-sidebar__content">
    <h3>{{ pageTitle}}</h3>
    <form [formGroup]="form" (ngSubmit)="submitButtonEvent.emit(form)" [id]="formName">
      <ng-content>

      </ng-content>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open -extra-width">
  <app-submit-row-buttons [form]="formName"
                          [isFieldValid]="isFormValid"
                          [cancelButtonText]="cancelButtonText"
                          [submitButtonText]="submitButtonText"
                          [spinnerName]="spinnerName"
                          (cancelButton)="cancelButtonEvent.emit(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space -has-transition -is-open"
     (click)="cancelButtonEvent.emit(false)">
  <span class="esf-hamburger__icon"></span>
</div>